<template>
  <el-container class="container--main">
    <el-aside
      class="aside__nav"
      :class="showControl ? 'aside__nav--opened' : 'aside__nav--closed'"
    >
      <navigationMenu @close-nav="showControl = false"></navigationMenu>
    </el-aside>
    <el-container class="container-body">
      <el-header class="header__nav">
        <dashboard-header
          :hideNavButton="isNecessaryInfoFilled"
        ></dashboard-header>
      </el-header>
      <template v-if="isNecessaryInfoFilled">
        <div class="container-body__main">
          <!-- <div v-if="isNecessaryInfoFilled" @click="toggleNavigation" class="aside-nav-opener"></div> -->
          <router-view :key="getCurrUserLocationId"></router-view>
        </div>
      </template>
      <el-container class v-else>
        <necessaryUserDetails />
      </el-container>
    </el-container>
    <er-dialog
      :visible="showWelcomeDialog"
      :close-on-click-modal="false"
      width="30%"
      :before-close="handleClose"
      custom-class="welcome-pondlogs-dialog"
    >
      <el-row type="flex" slot="header">
        <pondlogs-logo class="menu-icon" color="#0A2463"></pondlogs-logo>
        <p class="el-dialog__title">{{ $t("welcome_message_v2_header") }}</p>
      </el-row>
      <p class="dialog-main-item-title">
        {{ $t("welcome_message_v2_main_header") }}
      </p>
      <el-timeline>
        <el-timeline-item>
          {{ $t("welcome_message_v2_main_l1") }}
        </el-timeline-item>

        <el-timeline-item>
          {{ $t("welcome_message_v2_main_l2") }}
        </el-timeline-item>

        <el-timeline-item>
          {{ $t("welcome_message_v2_main_l3") }}
        </el-timeline-item>
      </el-timeline>
      <div slot="footer" class="dialog-footer">
        <er-button
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          size="mini"
          @click="handleClose"
        >
          {{ $t("Comn_continue") }}
        </er-button>
      </div>
    </er-dialog>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import navigationMenu from "@/components/dashboard/navigationMenu";
import dashboardHeader from "@/components/dashboard/header";
import necessaryUserDetails from "@/views/necessaryUserDetails";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import localStore from "@/utils/localStore";
import pondlogsLogo from "@/components/dashboard/pondlogsLogo";
export default {
  mixins: [errorHandlerMixin],
  components: {
    navigationMenu,
    dashboardHeader,
    necessaryUserDetails,
    pondlogsLogo
  },
  data() {
    return {
      loading: false,
      showWelcomeDialog: false
    };
  },
  async mounted() {
    this.showWelcomeDialog = localStore.getItem("show-welcome-dialog");
    this.$i18n.locale =
      localStorage.getItem(`lang`) ||
      (this.getUserCountryName.toLowerCase() === "india" ? "en" : "es");
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("user", {
      getUserCountryName: "getUserCountryName",
      getUserProfile: "getUserProfile",
      getCurrUserLocation: "getCurrUserLocation"
    }),
    ...mapGetters("header", {
      showControl: "getSideNavStatus"
    }),
    getCurrUserLocationId() {
      return this.getCurrUserLocation._id;
    },
    MapRouteNameNavIndex() {
      return {
        dashboard: "Comn_dashboard",
        map: "Comn_map",
        ponds: "Comn_ponds",
        battery: "Comn_battery",
        manualFeeding: "Comn_manual_feeding",
        pondFeeding: "PM_pond_feeding",
        pondMotherFeeding: "Comn_pond_mother",
        checkTray: "Comn_check_tray",
        cultureMedicine: "Comn_culture_medicine",
        abw: "ABW_abw",
        labTests: "LabTst_lab_tests",
        yield: "Comn_yield",
        stockedFeed: "Comn_feed",
        stockedMedicine: "Comn_stock_medicine",
        gateway: "Comn_gateway",
        reports: "Comn_reports",
        resources: "Comn_resources",
        settings: "Comn_settings"
      };
    },
    isNecessaryInfoFilled() {
      if (!this.isCountryFilled || !this.isTimezoneFilled) {
        return false;
      }
      return true;
    },
    isCountryFilled() {
      if (
        !this.getUserProfile.country ||
        !this.getUserProfile.country.name ||
        !this.getUserProfile.country.code
      ) {
        return false;
      }
      return true;
    },
    isTimezoneFilled() {
      if (
        !this.getUserProfile.timezone ||
        !this.getUserProfile.timezone.name ||
        this.getUserProfile.timezone.offset === undefined ||
        this.getUserProfile.timezone.offset == null
      ) {
        return false;
      }
      return true;
    }
  },

  methods: {
    ...mapActions("user", {
      fetchUserLocations: "fetchUserLocations",
      fetchUserProfile: "fetchUserProfile"
    }),
    ...mapActions("header", {
      changeSideNavStatus: "changeSideNavStatus"
    }),
    toggleNavigation: function() {
      this.changeSideNavStatus(!this.getSideNavStatus);
    },
    handleClose() {
      this.showWelcomeDialog = false;
      localStore.setItem("show-welcome-dialog", false);
    },
    async logout() {
      await this.$store.dispatch("auth/signOut");
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
.container--main {
  $navigation-width-onopen: 200px;
  $navigation-width-onclose: 50px;
  display: grid;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  grid: 1fr / auto 1fr 0;
  .header__nav {
    height: var(--header-height) !important;
    position: relative;
    border-bottom: 1px solid #dcdfe6;
    top: 0px;
    left: 0px;
    right: 0px;
  }
  .nav__controller {
    position: relative;
    display: inline-flex;
    align-items: center;
    font-size: 25px;
    z-index: 1000;
    padding: 0px;
    margin-right: 0.7em;
    border-width: 1px;
    border-color: #e6e6e6;
    border-radius: 5px;
  }
  .nav__controller--opened {
    left: $navigation-width-onopen;
  }
  .nav__controller--closed {
    // left: -10px;
    left: 50px;
  }
  .aside__nav {
    position: relative;
    z-index: 2001;
    height: 100vh;
  }
  .aside-nav-opener {
    z-index: 1000;
    height: 100vh;
    position: absolute;
    width: 6px;
    pointer-events: all;
  }
  .aside__nav .el-scrollbar {
    height: 100%;
    box-sizing: border-box;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .aside__nav--closed {
    width: $navigation-width-onclose !important;
    transition: 0.4s width ease-in-out, 0.4s padding-left ease-in-out,
      0.4s padding-right ease-in-out;
    transition-property: width, padding-left, padding-right;
    transition-duration: 0.4s, 0.4s, 0.4s;
    transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
    transition-delay: 0s, 0s, 0s;
    .el-submenu__title {
      display: none;
    }
    .navigation-menu .el-submenu:nth-last-child(2) {
      margin: 0;
    }
  }
  .aside__nav--opened {
    width: $navigation-width-onopen !important;
    transition: 0.4s width ease-in-out, 0.4s padding-left ease-in-out,
      0.4s padding-right ease-in-out;
    transition-property: width, padding-left, padding-right;
    transition-duration: 0.4s, 0.4s, 0.4s;
    transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
    transition-delay: 0s, 0s, 0s;
  }
  .container-body {
    height: 100%;
  }
  .container-body__main {
    flex-grow: 1;
    height: 0px;
    min-height: 0px;
    padding: 0px 0px 0px 0px;
    overflow: hidden;
  }
  .dialog-main-item-title {
    padding-bottom: 20px;
  }
  .el-timeline .el-timeline-item:last-child {
    padding-bottom: unset;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
